import {
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ComposedChart,
  CartesianGrid,
  ResponsiveContainer,
} from 'recharts';

import moment from 'moment';
import { isEmpty } from 'lodash';
import { currencyFormatter } from 'utils/formatters';
import { ArrowNarrowRightIcon } from '@heroicons/react/solid';
import ChartToolTip from 'components/Charts/ChartTooltip';

const MMRDifference = ({
  loading,
  summary = {},
  records = [],
  setOpenClientList,
  setClientListFilterGroups,
}) => {
  return (
    <div className="bg-white p-4">
      <div className="pb-5 pt-2 flex items-center justify-between">
        <p className="font-inter font-bold tracking-3/4 text-grayscale-900">
          MRR Beginning and MRR End
        </p>

        {!isEmpty(summary) && (
          <div>
            <p className="font-inter leading-1.2 tracking-3/4 text-xl text-grayscale-900 flex items-center space-x-2">
              <span>{currencyFormatter(summary.previousMonthlyRetainer)}</span>
              <span>
                <ArrowNarrowRightIcon className="w-5 h-5" />
              </span>
              <span>{currencyFormatter(summary.monthlyRetainer)}</span>
            </p>
          </div>
        )}
      </div>

      <div className="h-64">
        {loading ? (
          <div className="flex items-center justify-center h-full">
            <p className="text-2xl text-grayscale-700 animate-pulse tracking-2 leading-1.5 font-inter text-center items-center">
              Loading Data.....
            </p>
          </div>
        ) : (
          <ResponsiveContainer width={'100%'} height="100%" debounce={50}>
            <ComposedChart data={records}>
              <CartesianGrid stroke="#ECECEC" strokeDasharray="5 5" />
              <XAxis
                dataKey="dateRange"
                style={{
                  fontSize: '11px',
                  color: '#202020',
                  cursor: 'pointer',
                }}
                tickFormatter={(dateRange) =>
                  moment(dateRange.split('--')[0]).format('MMM')
                }
                onClick={(e) => {
                  const [startDate, endDate] = e.value.split('--');

                  setClientListFilterGroups(
                    JSON.stringify([
                      {
                        filters: [
                          {
                            attribute: 'contractSigned',
                            operator: 'LTE',
                            value: endDate,
                          },
                          {
                            attribute: 'subscriptionPaymentOption',
                            operator: 'EQ',
                            value: 'Recurring',
                          },
                          {
                            attribute: 'status',
                            operator: 'EQ',
                            value: 'ACTIVE',
                          },
                        ],
                      },
                      {
                        filters: [
                          {
                            attribute: 'contractSigned',
                            operator: 'LTE',
                            value: endDate,
                          },
                          {
                            attribute: 'subscriptionPaymentOption',
                            operator: 'EQ',
                            value: 'Recurring',
                          },
                          {
                            attribute: 'terminatedAt',
                            operator: 'HAS_PROPERTY',
                          },
                        ],
                      },
                    ])
                  );

                  setOpenClientList(true);
                }}
              />
              <YAxis
                yAxisId="0"
                orientation="left"
                stroke="#8884d8"
                style={{ fontSize: '11px' }}
              />

              <Tooltip
                content={
                  <ChartToolTip
                    Title={({ payload }) => (
                      <p className="text-13 font-bold leading-1.5 text-grayscale-900">
                        {moment(payload[0].payload.startDate).format('MMM')}
                      </p>
                    )}
                  />
                }
              />

              <Bar
                name="Beginning"
                yAxisId="0"
                stroke="#3BD7AD"
                fill="#3BD7AD"
                dataKey={'previousMonthlyRetainer'}
                dot={false}
                strokeWidth={3}
                formatter={(value) => currencyFormatter(value)}
              />

              <Bar
                yAxisId="0"
                stroke="#00966D"
                fill="#00966D"
                dataKey={'monthlyRetainerAndUpsoldAmount'}
                dot={false}
                strokeWidth={3}
                name="End"
                formatter={(value) => currencyFormatter(value)}
              />
            </ComposedChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
};

export default MMRDifference;
